module.exports = __webpack_public_path__ + "img/3dreal-logo@2x.7b36667b.png";